import { formatCurrency, formatNumber } from '@angular/common';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

// interfaces
import { IRega } from 'src/app/core/interfaces/ads/rega';

// shared standalone
import { ITab } from 'src/app/shared.standalone/tabs/interfaces/tab';

@Component({
  selector: 'app-rega-ad-data',
  templateUrl: './rega-ad-data.component.html',
  styleUrls: ['./rega-ad-data.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RegaAdDataComponent implements OnInit {

  /**
   * inputs
   */
  @Input({ alias: 'data', required: true }) public Data: IRega = null

  /**
   * fields
   */
  public ActiveTab: string | number = 1;
  public regaDetailsTabs: ITab[] = [
    { id: 1, title: 'تفاصيل الوسيط'},
    { id: 2, title: 'الموقع'},
    // { id: 3, title: 'الحدود والاطوال'},
    { id: 4, title: 'مواصفات'},
  ];


  /**
   *  Methods
   */
  ngOnInit(): void {}

  /**
   * 
   * @param key typeof IRega
   * @returns Property Value of rega ad data
   */
  public PropertyValueHandler(key: string | string[]): string {
    
    /**
     * 
     */
    if (typeof key == 'string') {
      if (Object.hasOwn(this.Data || {}, key) && this.Data[key] != null) {
        if (Array.isArray(this.Data[key]) && this.Data[key].length > 0) return this.Data[key].join(', ')
        else if (typeof this.Data[key] != 'object' && this.Data[key]?.toString()?.length > 0) return this.Data[key]
      }
    }
    else if (Array.isArray(key)) {
      
      /**
       * init
       */
      let props: {} | string = {...this.Data};
      
      /**
       * loop to deep in obj to get ref
       */
      key.forEach(k => {

      if (Object.hasOwn(props || {}, k) && props[k] != null) props = props[k]

      });

      /**
       * if it string return it 
       */
      if (Array.isArray(props)) return props.join(', ')
      else if (typeof props != 'object' && props?.toString()?.length > 0) return props?.toString()

    }
    
    /**
     * 
     */
    return 'غير محدد';
    

  }


  /**
   * 
   * @returns 
   */
  public RerBordersHandler(): string {

    /**
     * 
     */
    if (Array.isArray(this.Data?.rerBorders) && this.Data?.rerBorders.length > 0) {
      
      return this.Data.rerBorders.map(rb => {

        // ES6 Destruction
        const { direction, type, length } = rb;

        return `
          <span class="border_def_3th">
            الاتجاة: ${direction}
            <br />
            نوع الحد: ${type}
            <br />
            طول الحد: ${length}
          </span>
        `

      }).join('')

    }

    /**
     * 
     */
    return 'غير محدد';  
    
  }

  /**
   * 
   * @param key typeof IRega
   * @returns Property Value of rega ad data
   */
  public PropertyValueConcatenationHandler(key: string, type?: 'currency' | 'size') {

    try {

      /**
       * handler undefined key
       */
      if (key == null) throw new Error('key arg is undefined');
      if (this.Data[key] === undefined) throw new Error('key is undefined at Data');
  
      /**
       * handler null value
       */
      if (this.Data[key] === null) throw 'غير محدد';
  
      /**
       * handler price value
       */
      switch(type) {
        case 'currency':
          return formatCurrency(this.Data[key], 'en-US', '', '', '0.0-0').trim() + ' ريال ';
        case 'size':
          return formatNumber(this.Data[key], 'en-US', '0.0-0') + ' م2 '
        default:
          return this.Data[key]
      }

    } catch (err: any) {
      new Error(err)
      return 'غير محدد';
    }

  }

  /**
   * 
   */
  public PropertyLatAndLngHandler(): string {

    // ES6 Destruction
    const { latitude, longitude } = this.Data?.location || {}

    /**
     * 
     */
    try {

      /**
       * handler nullable values
       */
      if (latitude === null || longitude === null) throw 'lat & lng is undefined';

      /**
       * 
       */
      return `<a target='_blank' href='https://www.google.com/maps?q=${latitude},${longitude}'>معاينة الموقغ <i class="fa-solid fa-location-dot"></i></a>`

    } catch (err: any) {
      new Error(err)
      return 'غير محدد';
    }

  }

  /**
   * 
   * @param tab ITab
   */
  public ActiveTabChange(tab: ITab): void {

    this.ActiveTab = tab?.id

  }

}
